export default class FormatDate {
  /**
   * Takes a Date object and returns a string in the format YYMMDD.
   *
   * @param {Date} date - The date to be formatted
   * @return {string} The formatted date string
   */
  static toYYMMDD(date: Date): string {
    try {
      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString();
      const day = date.getDate().toString();
      return `${year.substring(2, 4)}${month.padStart(2, "0")}${day.padStart(
        2,
        "0"
      )}`;
    } catch (ex) {
      return "";
    }
  }
  /**
   * Returns a string representation of the given date in the format YYYY-MM-DD.
   *
   * @param {Date} date - The date to be formatted.
   * @return {string} A string representation of the given date in the format YYYY-MM-DD.
   *                  If the date cannot be formatted, an empty string is returned.
   */
  static toYYYY_MM_DD(date: Date): string {
    try {
      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString();
      const day = date.getDate().toString();
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    } catch (ex) {
      return "";
    }
  }

  static getLocale(): string {
    return Intl.DateTimeFormat().resolvedOptions().locale;
  }
}
